function ConditionsController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.createMode = false;
    ctrl.conditions = [];
    const selectedCondition = stateService.getSelectedCondition();
    if (selectedCondition) {
      ctrl.selection = selectedCondition;
    }
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.$onChanges = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.isLocked = selectedWorkspace.deployable;
    getAllconditions();
  };

  ctrl.setCreateMode = () => {
    stateService.setSelectedCondition(null);
    ctrl.selection = null;
    ctrl.createMode = true;
    ctrl.$onChanges();
  };

  ctrl.goBackToList = () => {
      $state.go('pis.workspaces.condition-list');
  };

  ctrl.onConditionDelete = event => {
    stateService.deleteCondition(ctrl.workspaceId, event.conditionId).then(
      response => {
        ctrl.selection = null;
        getAllconditions();
        toasterService.success('toaster.pis-event', 'toaster.pis-condition-delete');
      },
      function(e) {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.log(e);
      }
    );
  };



  const getAllconditions = () => {
    stateService.getConditions(ctrl.workspaceId).then(conditions => {
      ctrl.conditions = conditions;
    })
  };
}

angular
  .module('pis-tool.module')
  .controller('ConditionsController', ConditionsController);
